import axiosHttp from "services/axiosHttp";

// Customer Service Functions
export const customerService = {
  // Create customer
  createCustomer: async (data) => {
    const response = await axiosHttp.post("/pmo/customer", data);
    return response.data;
  },

  // Get customer list with optional params
  getCustomerList: async (params = {}) => {
    const response = await axiosHttp.get("/pmo/customer", { params });
    return response.data;
  },

  // Get single customer by ID
  getCustomer: async (id) => {
    const response = await axiosHttp.get(`/pmo/customer/${id}`);
    return response.data;
  },

  // Update customer
  updateCustomer: async (id, data) => {
    const response = await axiosHttp.put(`/pmo/customer/${id}`, data);
    return response.data;
  },

  // Delete customer
  deleteCustomer: async (id) => {
    const response = await axiosHttp.delete(`/pmo/customer/${id}`);
    return response.data;
  },
};

